module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/stop-c9d1e637d22529649e610fb626c21ad9.png";